<app-top-nav-bar> </app-top-nav-bar>

<div class="content" fxFlex>
    <router-outlet></router-outlet>
</div>
  
<app-footer></app-footer>
  